module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ci-alert"
  }, [_c('h1', [_vm._v("您没有权限访问这个界面")]), _vm._v(" "), _c('h1', [_vm._v("请联系管理员以获得此权限")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7aade7a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/ci-components/components/noAccess.vue
// module id = 258
// module chunks = 4